import noop from 'lodash/noop';
import React, { useReducer, createContext } from 'react';
import PropTypes from 'prop-types';
import uiReducer from '../reducers/ui';

const UIContext = createContext({
  state: {
    isSuccessNotificationShown: false,
    isFailureNotificationShown: false,
    isSubmitInProgress: false,
    isGetQuestionsInProgress: false,
    isSurveyEnabled: true,
    isSurveySubmitted: false,
  },
  dispatch: noop,
});

export const UIState = ({ children }) => {
  const [state, dispatch] = useReducer(uiReducer, {
    isSuccessNotificationShown: false,
    isFailureNotificationShown: false,
    isSubmitInProgress: false,
    isGetQuestionsInProgress: false,
    isSurveyEnabled: true,
    isSurveySubmitted: false,
  });
  return (
    <UIContext.Provider
      value={{
        state,
        dispatch,
      }}>
      {children}
    </UIContext.Provider>
  );
};

UIState.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UIContext;
